export default __webpack_public_path__ + "static/media/popcorn-pieces-04.da0873aa.png";